module.exports = __webpack_public_path__ + "img/op_img-header.04dcd87.png";